<div class="wrap">
	<div class="card-button-group">
		<button class="button-general" [disabled]="isGenerating" (click)="generate()">Generate</button>
	</div>
	<div class="report-types">
		<select name="reportTypes" [(ngModel)]="selectedReportType" (ngModelChange)="onSelectReportType()">
			<option *ngFor="let reportType of reportTypes" [ngValue]="reportType">{{reportType.label}}</option>
		</select>
	</div>
	<app-interlayer-report-tabs></app-interlayer-report-tabs>
	<div class="filter-options">
		<div *ngFor="let option of filterOptions; let idx = index;" 
			class="filter-option-item" 
			[title]="option.descriptionLong"
			(mouseover)="onMouseoverCode(option)"
			(mouseout)="onMouseoutCode()">
			<div class="option-checkbox">
				<div style="padding:3px 0px 0px;">
					<input type="checkbox" name="option-{{idx}}"
						[(ngModel)]="option.isSelected"
						[disabled]="!option.count"
						(ngModelChange)="toggleFilterOption(option)"
					>
				</div>
			</div>
			<div *ngIf="selectedReport&&selectedReport.type==='FISHBONE'" class="option-legend" [ngSwitch]="option.value">
				<div *ngSwitchCase="'FS1'" class="legend-circle legend-circle-small">
					<div class="legend-black"></div>
				</div>
				<div *ngSwitchCase="'FS2'" class="legend-circle legend-circle-small">
					<div class="legend-red"></div>
				</div>
				<div *ngSwitchCase="'FS3'" class="legend-circle legend-circle-large">
					<div class="legend-black"></div>
				</div>
				<div *ngSwitchCase="'FS4'" class="legend-circle legend-circle-large">
					<div class="legend-red"></div>
				</div>
				<div *ngSwitchCase="'FS5'" class="legend-diamond legend-diamond-large">
					<div class="legend-red"></div>
				</div>
				<div *ngSwitchCase="'FS6'" class="legend-diamond legend-diamond-large">
					<div class="legend-red"></div>
				</div>
				<div *ngSwitchCase="'FS7'" class="legend-diamond legend-diamond-small">
					<div class="legend-red"></div>
				</div>
				<div *ngSwitchCase="'FS8'" class="legend-diamond legend-diamond-small">
					<div class="legend-red"></div>
				</div>
				<div *ngSwitchCase="'FS9'" class="legend-triangle legend-triangle-large">
					<div></div>
				</div>
				<div *ngSwitchCase="'FSA'" class="legend-line-thin">
					<div class="legend-red"></div>
				</div>
				<div *ngSwitchCase="'FSB'" class="legend-line-thin">
					<div class="legend-red"></div>
				</div>
			</div>
			<label class="option-label" [title]="option.descriptionLong"><span [ngClass]="{'item-with-tooltip': option.descriptionLong}">{{option.value}}</span>{{' - ' + option.name}}</label>
			<div class="option-count">{{option.count ? option.count : ''}}</div>
		</div>
	</div>
</div>

